<!--
Main router element and build info.

@stable
-->

<zef-global-spinner />

<router-outlet />

@if (build) {
  <div class="zef-build">{{ build }} build, version: {{ version }}</div>

  @if (eh.error()) {
    <div class="zef-error" (click)="eh.error.set(false)">Errors detected, check the console for more information.</div>
  }
}

<div class="zef-portal"></div>
<div id="recaptcha-container-id" style="position: relative; z-index: 1"></div>

<esko-agent-bubble />
